module.exports = __webpack_public_path__ + "img/climbing-modal-icon.46ebc0f4.svg";